export const DELETE_VOUCHER_MUTATION_V2 = `
mutation CartPageMutation{
  deleteVoucher {
      data {
          pricesSummary {
              vat
              priceItemSummary
              pricePayment
              priceDelivery
              priceProductsSummary
              discountWithoutDelivery
          }
          benefits {
            loyalty {
              loyalties {
                  percentageValue
                  localizedNavigationName
                  discountType
                  loyaltyType
                  value
                  state
                  tags
                  orderPriceActivationThresholdWithVat
                  minimalOrderPriceThresholdWithVat
                  expirationDate
                  validUntil
              }
            }
            vouchers {
              code
              value
              isDeliveryVoucher
            }
          }
      }
      messages
  }
}
`;
